// @ts-nocheck
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  forwardRef,
} from '@angular/core';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { NgTryForDirective } from '../../../directives/_old_directives/ng-try-for.directive';
import { BodyFeedbackComponent } from '../body-feedback/body-feedback.component';
import { FormControlStructure } from './dynamic-form.model';
import { DynamicFormService } from './dynamic-form.service';
import { ModuleComponent } from './module/module.component';

@Component({
  selector: 'lbca-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  providers: [DynamicFormService],
  imports: [
    NgTryForDirective,
    forwardRef(() => ModuleComponent),
    forwardRef(() => BodyFeedbackComponent),
  ],
})
export class DynamicFormComponent implements OnInit, AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();

  public data: any = {};
  public configurations: any = [];
  public error: any = {};

  public unlockDynamicForm = true;

  private formId: string | null = null;
  private cardId: string | null = null;

  public disabled = false;
  public initialized = false;
  public isOpenForced = true;
  public origin = '';

  loaded = false;

  public externalData: any;
  public cardInfo: any;

  public formType: 'form-primary' | 'modal' | 'form-secondary' = 'form-primary';

  private validationsFunctions: Array<any> = [];
  public processNumber: string | null = null;
  public attr = {};

  public controlStructure = new BehaviorSubject(true);

  @Input()
  set modulesConfig(data: Array<any>) {
    if (data && Array.isArray(data) && !!data.length) {
      this.dynamicFormService.convertSubformsToControlStructure(data).then(() => {
        this.controlStructure.next(false);
      });
      this.configurations = data;
    }
    // Timeout espera a estrutura de depencia ser carregada
    // setTimeout(() => {
    //   this.processInterdependency(data);
    // }, 250)
  }

  @Input('externalData') set dataValue(data: any) {
    this.controlStructure
      .pipe(
        takeUntil(this.destroy$),
        takeWhile((val) => val, true)
      )
      .subscribe((val) => {
        if (!val) {
          this.dynamicFormService.initializeFieldControlValues(data);
        }
      });
    this.externalData = data;
  }

  @Input() set cardData(data: any) {
    this.cardInfo = data;
  }
  @Input('initialized') set initValue(init: boolean) {
    this.initialized = init;
  }
  @Input() set modulesData(data: Object) {
    this.data = data;
  }
  @Input() set type(type: 'form-primary' | 'modal' | 'form-secondary') {
    this.formType = type;
  }
  @Input('formId') set idOfForm(id: string) {
    this.formId = id;
  }
  @Input('cardId') set idOfCard(id: string) {
    this.dynamicFormService.taskId = id;
    this.cardId = id;
    this.attr = {
      bpmIdCard: this.cardId || null,
    };
  }

  @Input('origin') set setOrigin(val: string) {
    this.origin = val;
  }
  public context: string | null = null;
  @Input('context') set contextSetter(val: string) {
    this.context = val;
  }
  @Input('processNumber') set numberOfProcessFlow(num: string) {
    this.processNumber = num;
  }
  @Input('disabled') set disabledSetter(status: boolean) {
    this.disabled = status;
  }
  @Input('forceStateOpened') set openStatus(isOpen: boolean) {
    this.isOpenForced = isOpen;
  }
  @Input() set errorPostData(dataError: Array<any>) {
    for (const err in dataError) {
      const error = dataError[err];
      this.dynamicFormService.setFormControlData(error.idSubForm)(error.entityKey, 'error', [
        JSON.stringify(error.message),
      ]);
    }
  }

  @Input('error') set err(error) {
    const subFormModuleInstance = this.dynamicFormService.setFormControlData("don't care");

    if (Array.isArray(error)) {
      error.forEach((err) => {
        subFormModuleInstance(err.entityKey, 'error', [err.message]);
      });
    }

    this.error = error;
  }
  @Output() unlockViewDynamicForm = new EventEmitter();

  @Output() controlCloud = new EventEmitter();
  @Output('formValidFunctionCallback') formValidCalbackEmmiter = new EventEmitter();
  @Output('errorApi') errorApiEmmiter = new EventEmitter();
  @Output('feedback') feedbackEmmiter = new EventEmitter();
  @Output('subformData') subformDataEmitter = new EventEmitter();
  @Output('saveData') saveDataEmmiter = new EventEmitter();
  @Output() eventEmitter = new EventEmitter();
  @Output() completeDataEmitter = new EventEmitter();
  @Output() setPageIniciatedEmmiter = new EventEmitter();

  @Output() emitEmmitterDynamicService = new EventEmitter();
  @Input('triedSubmit') set setterTriedSubmit(triedSubmit: boolean) {
    if (typeof triedSubmit === 'boolean') this.dynamicFormService.triedSubmit = triedSubmit;
  }

  feedbackSubscription: Subscription;
  saveSubscription: Subscription;
  formSubscription: Subscription;
  eventSubscription: Subscription;

  constructor(private dynamicFormService: DynamicFormService) {
    // this.dynamicFormService = new DynamicFormService();
    this.feedbackSubscription = this.dynamicFormService.feedbackEmitter.subscribe((feed) =>
      this.feedbackEmmiter.emit(feed)
    );

    this.saveSubscription = this.dynamicFormService.saveEmitter.subscribe((data) => {
      this.saveDataEmmiter.emit(data);
    });

    this.formSubscription = this.dynamicFormService.formControlStructureChanged.subscribe(
      (struct: FormControlStructure) => this.subformDataEmitter.emit(struct)
    );
    this.eventSubscription = this.dynamicFormService.eventEmitter.subscribe((event: any) =>
      this.eventEmitter.emit(event)
    );
  }

  ngAfterViewInit(): void {
    this.loaded = true;
  }

  ngOnInit(): void {
    this.formValidCalbackEmmiter.emit(this.formValidCallbackFunction);
    this.dynamicFormService.setFormMetadata({
      ...this.cardInfo,
      processId: this.processNumber,
      origin: this.origin,
    });
    this.dynamicFormService.unlockDynamicFormEmitter.subscribe((resp) => {
      this.unlockDynamicForm = resp;
      this.unlockViewDynamicForm.emit(this.unlockDynamicForm);
    });
    this.emitEmmitterDynamicService.emit(this.dynamicFormService.setFormControlData);

    this.completeDataEmitter.emit(this.dynamicFormService.getValuesCompleteToSave);
    this.setPageIniciatedEmmiter.emit(this.dynamicFormService.setPageIniciated);
  }

  public erroApi(event): void {
    this.errorApiEmmiter.emit(event);
  }

  public setCalbacksArray(validFuntion) {
    this.validationsFunctions.push(validFuntion);
  }

  public saveData(event) {
    this.saveDataEmmiter.emit(event);
  }

  ngOnDestroy(): void {
    this.feedbackSubscription?.unsubscribe();
    this.saveSubscription?.unsubscribe();
    this.formSubscription?.unsubscribe();

    this.destroy$.complete();
  }

  public getEntityDataValues(entityKey) {
    const dataValues = this.data ? this.data[entityKey] : null;

    const attrs = {
      entityKey,
      formId: null,
      bpmIdCard: this.cardId || null,
    };

    if (dataValues) {
      attrs['entityId'] = dataValues.entityId;
      attrs['entityInstanceId'] = dataValues.entityIdValue;
    }

    return { ...attrs };
  }

  setControlCloud(value) {
    this.controlCloud.emit(value);
  }

  public formValidCallbackFunction = () => {
    let hasError = false;
    this.validationsFunctions.forEach((fn) => (hasError = fn() || hasError));
    return !hasError;
  };
}
